webpackJsonp([1],{

/***/ "+BTi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+Rdb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/I4U":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2rGO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3f40":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4awP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{staticStyle:{"height":"100%"}},[_c('el-col',{staticStyle:{"height":"100%"},attrs:{"xs":24,"sm":24,"md":{ span: 16, offset: 4 },"lg":{ span: 14, offset: 5 },"xl":{ span: 12, offset: 6 }}},[_c('div',{attrs:{"id":"bk"}},[_c('div',{staticClass:"main"},[_c('img',{staticClass:"logo",attrs:{"src":"static/logo.png"}}),_vm._v(" "),_c('quill-editor',{ref:"editor",staticClass:"editor",attrs:{"id":"editor","options":_vm.editorOption,"disabled":_vm.step > 1},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}}),_vm._v(" "),_c('div',{staticClass:"tip"},[_c('div',{staticStyle:{"font-weight":"bold","padding":"10px 0px"}},[_vm._v("使用说明：")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("网站只存储加密后的信息，返回给你一个访问链接")]),_vm._v(" "),_c('li',[_vm._v("用链接可无须登陆直接取回加密后的信息，但需要自己解密")]),_vm._v(" "),_c('li',[_vm._v("或者把下载的内容粘贴在这里帮你解密")]),_vm._v(" "),_c('li',[_vm._v("加密算法采用AES，使用crypto-js库，"),_c('el-button',{staticStyle:{"font-size":"inherit"},attrs:{"type":"text"},on:{"click":_vm.onShowCode}},[_vm._v("参考代码")]),_vm._v(" "),(_vm.bShowCode)?_c('pre',[_vm._v("                            "),_c('code',[_vm._v("\n// 加密\nfunction aesEncrypt(data, key) {\n    var encrypted = CryptoJS.AES.encrypt(data, key, {\n        mode: CryptoJS.mode.ECB,\n        padding: CryptoJS.pad.Pkcs7\n    });\n    return encrypted.toString();\n}\n\n// 解密\nfunction aesDecrypt(ciphertext, key) {\n    var decrypted = CryptoJS.AES.decrypt(ciphertext, key, {\n        mode: CryptoJS.mode.ECB,\n        padding: CryptoJS.pad.Pkcs7\n    });\n    return decrypted.toString(CryptoJS.enc.Utf8);\n}\n                                ")]),_vm._v("\n                                ")]):_vm._e()],1),_vm._v(" "),_c('li',[_vm._v("信息大小限制为10M")]),_vm._v(" "),_c('li',[_vm._v("信息免费保留24小时，每日可下载250次，超限删除")]),_vm._v(" "),_c('li',[_vm._v("如果需要更多的保留时间和下载次数请联系QQ：642128162购买延期代码")])])]),_vm._v(" "),(!_vm.bShowCaptcha)?_c('div',{staticClass:"tool"},[_c('el-input',{staticClass:"input",attrs:{"placeholder":"请输入密码","placeholderStyle":"color:#999;"},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}),_vm._v(" "),_c('el-input',{staticClass:"input",attrs:{"placeholder":"延期代码(可选)","placeholderStyle":"color:#999;"},model:{value:(_vm.delayCode),callback:function ($$v) {_vm.delayCode=$$v},expression:"delayCode"}}),_vm._v(" "),_c('el-button',{staticClass:"btn",attrs:{"type":"primary","size":"small"},on:{"click":_vm.onEncryp}},[_vm._v("加密存储")]),_vm._v(" "),_c('el-button',{staticClass:"btn",attrs:{"type":"primary","size":"small"},on:{"click":_vm.onDecryp}},[_vm._v("解密")])],1):_c('div',{staticClass:"captchaview",attrs:{"title":"人机验证"}},[_c('img',{staticStyle:{"width":"144px","height":"144px","margin":"0 auto"},attrs:{"src":_vm.qrCode,"alt":"QR Code"}}),_vm._v(" "),_c('p',{staticStyle:{"color":"#333","font-size":"14px","text-align":"center","padding":"10px"}},[_vm._v("\n                        请用任意微信扫码证明您是真实用户, 如果您用手机使用本网站，请截图后再用微信扫码")])])],1),_vm._v(" "),_c('div',{staticClass:"footer"},[_c('el-link',{attrs:{"type":"primary","href":"https://beian.miit.gov.cn/"}},[_vm._v("蜀ICP备2021013463号-2")])],1)]),_vm._v(" "),(_vm.bUploadDlg)?_c('div',{staticClass:"uploadprogress"},[_c('div',{staticClass:"uploadcenter"},[(_vm.uploadProgress === 100)?_c('el-progress',{staticClass:"progressCircle",attrs:{"type":"circle","stroke-width":12,"width":140,"percentage":_vm.uploadProgress,"status":"success"}}):_vm._e(),_vm._v(" "),_c('p',{staticClass:"uploadtip"},[_vm._v("上传完成，请记住你的下载链接:")]),_vm._v(" "),_c('el-link',{staticClass:"downUrl",attrs:{"href":_vm.downloadUrl}},[_vm._v(_vm._s(_vm.downloadUrl))]),_vm._v(" "),_c('div',{staticClass:"toolbar"},[_c('el-button',{staticClass:"uploadbtn",attrs:{"type":"success","size":"small"},on:{"click":_vm.onCopyUrl}},[_vm._v("复制链接")]),_vm._v(" "),_c('el-button',{staticClass:"uploadbtn",attrs:{"type":"success","size":"small"},on:{"click":_vm.onUploadOK}},[_vm._v("关闭")])],1)],1)]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4qOc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8jhb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8lYu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BNJR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Dte2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FGQs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var util = __webpack_require__("rQBB");

var _taskID = null;

function getBytesLength(str) {
    var buf = Buffer.from(str);
    return buf.length;
}

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'bk',
    components: {},
    data: function data() {
        return {
            bUploadDlg: false,
            downloadUrl: '',
            content: '',
            password: '',
            bShowCaptcha: false,
            authCode: '',
            qrCode: '',
            uploadSpeed: 0,
            uploadProgress: 0,
            bShowCode: false,
            delayCode: ''
        };
    },

    methods: {
        onEncryp: function onEncryp() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var n, text, id, loading, r;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (_this.password) {
                                    _context.next = 3;
                                    break;
                                }

                                _this.$msgbox({
                                    title: '错误',
                                    message: '请输入加密密码'
                                });
                                return _context.abrupt('return');

                            case 3:
                                n = getBytesLength(_this.content);

                                if (!(n === 0)) {
                                    _context.next = 7;
                                    break;
                                }

                                _this.$msgbox({
                                    title: '请先输入留言'
                                });
                                return _context.abrupt('return');

                            case 7:
                                if (!(n > 1024 * 1024 * 10)) {
                                    _context.next = 10;
                                    break;
                                }

                                _this.$msgbox({
                                    title: '留言大小超过5M，请减少内容'
                                });
                                return _context.abrupt('return');

                            case 10:
                                text = util.Encrypted(_this.password, _this.content); //加密ID作为检测用户密码输入是否正确的依据

                                console.log("加密结果：", text);
                                console.log("解密测试：", util.Decrypted(_this.password, text));

                                id = util.SHA1(text);
                                loading = _this.$loading({
                                    lock: true,
                                    text: '开始请求人机验证',
                                    spinner: 'el-icon-loading',
                                    background: 'rgba(0, 0, 0, 0.7)'
                                });
                                //请求人机验证

                                _context.next = 17;
                                return util.requestAuth(id);

                            case 17:
                                r = _context.sent;


                                loading.close();

                                if (r) {
                                    _context.next = 22;
                                    break;
                                }

                                _this.$msgbox({
                                    title: "提示",
                                    message: '请求人机验证失败，请稍后重试'
                                });
                                return _context.abrupt('return');

                            case 22:
                                _this.authCode = r.md5;
                                _this.qrCode = r.qrcode;
                                _this.bShowCaptcha = true;

                                console.log("开始等待扫码验证");
                                _context.next = 28;
                                return util.waitAuth(_this.authCode);

                            case 28:
                                r = _context.sent;


                                console.log("扫码验证结果：", r);

                                if (!(r.code == 1)) {
                                    _context.next = 35;
                                    break;
                                }

                                _this.$msgbox({
                                    title: "提示",
                                    message: '人机验证二维码超时，请重试'
                                });
                                _this.qrcode = '';
                                _this.bShowCaptcha = false;
                                return _context.abrupt('return');

                            case 35:

                                _this.bShowCaptcha = false;
                                _this.qrCode = '';

                                if (!(r.code != 0 || r.result != 1)) {
                                    _context.next = 42;
                                    break;
                                }

                                _this.$msgbox({
                                    title: "提示",
                                    message: '人机验证失败或超时，请稍后重试'
                                });
                                _this.qrcode = '';
                                _this.bShowCaptcha = false;
                                return _context.abrupt('return');

                            case 42:

                                r = JSON.parse(r.data);

                                console.log("授权结果：", r);

                                util.InitCos(r);

                                console.log("上传");

                                _context.next = 48;
                                return util.upload(id, text, function (taskId) {
                                    /* 非必须 */
                                    console.log("上传taskID:", taskId);
                                    _taskID = taskId;
                                    _this.bUploadDlg = true;
                                }, function () {
                                    /* 非必须 */

                                    _this.uploadProgress = parseInt(info.percent * 10000) / 100;
                                    _this.uploadSpeed = parseInt(info.speed / 1024 / 1024 * 100) / 100;
                                    console.log("progress:", info);
                                });

                            case 48:
                                r = _context.sent;

                                if (!r) {
                                    _context.next = 66;
                                    break;
                                }

                                _this.uploadProgress = 100;
                                loading = _this.$loading({
                                    lock: true,
                                    text: '正在提交...',
                                    spinner: 'el-icon-loading',
                                    background: 'rgba(0, 0, 0, 0.7)'
                                });
                                //注意，这里必须处理上传成功但提交失败的情况，那么就会出现
                                //存储桶保存没有记录的死文件
                                _context.prev = 52;
                                _context.next = 55;
                                return util.submit(id, _this.delayCode);

                            case 55:
                                r = _context.sent;
                                _context.next = 62;
                                break;

                            case 58:
                                _context.prev = 58;
                                _context.t0 = _context['catch'](52);

                                console.log("提交失败：", _context.t0);
                                r = null;

                            case 62:

                                loading.close();
                                if (!r) {
                                    _this.bUploadDlg = false;
                                    _this.$msgbox({
                                        title: '提示',
                                        message: '上传失败，请稍后重试'
                                    });
                                } else {
                                    console.log("提交结果：", r);
                                    _this.downloadUrl = util.getHost() + ('/getfile?id=' + id);
                                    _this.content = '';
                                    _this.password = '';
                                }
                                _context.next = 67;
                                break;

                            case 66:
                                _this.$msgbox({
                                    title: '提示',
                                    message: '上传失败，请稍后重试'
                                });

                            case 67:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this, [[52, 58]]);
            }))();
        },
        onDecryp: function onDecryp() {
            if (!this.content) {
                this.$msgbox({
                    title: '错误',
                    message: '请先粘贴下载的加密信息'
                });
                return;
            }
            if (!this.password) {
                this.$msgbox({
                    title: '错误',
                    message: '请输入解密密码'
                });
                return;
            }

            var t = this.content;
            var startIndex = t.indexOf("<p>") + 3;
            var endIndex = t.lastIndexOf("</p>");
            var s = t.substring(startIndex, endIndex);
            s = s.replace(/^\s+|\s+$/g, '');

            var text = util.Decrypted(this.password, s);
            this.content = text;
            this.password = '';
        },
        onCancleUpload: function onCancleUpload() {
            this.bUploadDlg = false;
            if (!_taskID) return;
            var cos = util.GetCosInstance();
            if (!cos) {
                return;
            }
            cos.pauseTask(_taskID);
        },
        onShowCode: function onShowCode() {
            this.bShowCode = !this.bShowCode;
        },
        onCopyUrl: function onCopyUrl() {
            var _this2 = this;

            if (!navigator.clipboard) {
                // Clipboard API not available
                this.$msgbox({
                    title: '无法拷贝链接',
                    type: 'error',
                    message: '\u8BF7\u81EA\u884C\u590D\u5236\u94FE\u63A5'
                });
                return;
            }
            navigator.clipboard.writeText(this.downloadUrl).then(function () {
                _this2.$msgbox({
                    title: '已经拷贝到剪贴板',
                    type: 'success'
                });
                return;
            }).catch(function (err) {
                console.log("err:", err);
                _this2.$msgbox({
                    title: '无法拷贝到剪贴板',
                    type: 'error'
                });
            });
        },
        onUploadOK: function onUploadOK() {
            this.bUploadDlg = false;
        }
    }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("EuP9").Buffer))

/***/ }),

/***/ "GXEp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IUI+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a9d5d19_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("PuRO");
function injectStyle (ssrContext) {
  __webpack_require__("8lYu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a9d5d19_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_message_css__ = __webpack_require__("cwe7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_message_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_chalk_message_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css__ = __webpack_require__("+BTi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_theme_chalk_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_message__ = __webpack_require__("2X9z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_notification_css__ = __webpack_require__("/I4U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_notification_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_notification_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_notification__ = __webpack_require__("yg6k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_message_box_css__ = __webpack_require__("oq7i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_message_box_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_message_box_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_message_box__ = __webpack_require__("+TD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_message_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_message_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_loading_css__ = __webpack_require__("2rGO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_loading__ = __webpack_require__("nu7/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_link_css__ = __webpack_require__("IUI+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_link_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_theme_chalk_link_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_link__ = __webpack_require__("h2ff");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_progress_css__ = __webpack_require__("uKbn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_progress_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_progress_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_progress__ = __webpack_require__("GegP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_progress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_progress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_col_css__ = __webpack_require__("jZDA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_col_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_theme_chalk_col_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_col__ = __webpack_require__("91Nw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_row_css__ = __webpack_require__("d7TW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_row_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_theme_chalk_row_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_row__ = __webpack_require__("ajQY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_element_ui_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_theme_chalk_form_item_css__ = __webpack_require__("+Rdb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_theme_chalk_form_item_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_element_ui_lib_theme_chalk_form_item_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_form_item__ = __webpack_require__("Mezo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_form_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_element_ui_lib_form_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_element_ui_lib_theme_chalk_form_css__ = __webpack_require__("qunJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_element_ui_lib_theme_chalk_form_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_element_ui_lib_theme_chalk_form_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_element_ui_lib_form__ = __webpack_require__("vqwl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_element_ui_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_element_ui_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_element_ui_lib_theme_chalk_date_picker_css__ = __webpack_require__("isgN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_element_ui_lib_theme_chalk_date_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_element_ui_lib_theme_chalk_date_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_element_ui_lib_date_picker__ = __webpack_require__("tLa+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_element_ui_lib_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_element_ui_lib_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_element_ui_lib_theme_chalk_table_column_css__ = __webpack_require__("Dte2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_element_ui_lib_theme_chalk_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_element_ui_lib_theme_chalk_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_element_ui_lib_table_column__ = __webpack_require__("q4le");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_element_ui_lib_theme_chalk_table_css__ = __webpack_require__("isE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_element_ui_lib_theme_chalk_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_element_ui_lib_theme_chalk_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_element_ui_lib_table__ = __webpack_require__("LR6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_element_ui_lib_theme_chalk_button_css__ = __webpack_require__("GXEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_element_ui_lib_theme_chalk_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_element_ui_lib_theme_chalk_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_element_ui_lib_button__ = __webpack_require__("mtrD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_element_ui_lib_theme_chalk_radio_group_css__ = __webpack_require__("BNJR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_element_ui_lib_theme_chalk_radio_group_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_element_ui_lib_theme_chalk_radio_group_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_element_ui_lib_radio_group__ = __webpack_require__("fDPO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_element_ui_lib_radio_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_element_ui_lib_radio_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_element_ui_lib_theme_chalk_radio_css__ = __webpack_require__("8jhb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_element_ui_lib_theme_chalk_radio_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_element_ui_lib_theme_chalk_radio_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_element_ui_lib_radio__ = __webpack_require__("RDoK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_element_ui_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_element_ui_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_element_ui_lib_theme_chalk_input_number_css__ = __webpack_require__("Zki6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_element_ui_lib_theme_chalk_input_number_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_element_ui_lib_theme_chalk_input_number_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_element_ui_lib_input_number__ = __webpack_require__("0kY3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_element_ui_lib_input_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_element_ui_lib_input_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_element_ui_lib_theme_chalk_input_css__ = __webpack_require__("X+ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_element_ui_lib_theme_chalk_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_element_ui_lib_theme_chalk_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_element_ui_lib_input__ = __webpack_require__("HJMx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_element_ui_lib_theme_chalk_dialog_css__ = __webpack_require__("Yq4J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_element_ui_lib_theme_chalk_dialog_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37_element_ui_lib_theme_chalk_dialog_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_element_ui_lib_dialog__ = __webpack_require__("qubY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_element_ui_lib_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38_element_ui_lib_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_vue_quill_editor__ = __webpack_require__("G0J2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_vue_quill_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42_vue_quill_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_quill_dist_quill_core_css__ = __webpack_require__("3f40");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_quill_dist_quill_core_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43_quill_dist_quill_core_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_quill_dist_quill_snow_css__ = __webpack_require__("4qOc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_quill_dist_quill_snow_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44_quill_dist_quill_snow_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_element_ui_lib_theme_chalk_index_css__ = __webpack_require__("tvR6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45_element_ui_lib_theme_chalk_index_css__);





























































// require styles


// import 'quill/dist/quill.bubble.css'
// import ElementUI from 'element-ui'

// import 'element-theme-chalk/lib/index.css';
// Vue.use(ElementUI)


// Vue.use(Pagination);
__WEBPACK_IMPORTED_MODULE_39_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_38_element_ui_lib_dialog___default.a);
// Vue.use(Autocomplete);
// Vue.use(Dropdown);
// Vue.use(DropdownMenu);
// Vue.use(DropdownItem);
// Vue.use(Menu);
// Vue.use(Submenu);
// Vue.use(MenuItem);
// Vue.use(MenuItemGroup);
__WEBPACK_IMPORTED_MODULE_39_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_36_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_39_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_34_element_ui_lib_input_number___default.a);
__WEBPACK_IMPORTED_MODULE_39_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_32_element_ui_lib_radio___default.a);
__WEBPACK_IMPORTED_MODULE_39_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_30_element_ui_lib_radio_group___default.a);
// Vue.use(RadioButton);
// Vue.use(Checkbox);
// Vue.use(CheckboxButton);
// Vue.use(CheckboxGroup);
// Vue.use(Switch);
// Vue.use(Select);
// Vue.use(Option);
// Vue.use(OptionGroup);
__WEBPACK_IMPORTED_MODULE_39_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_28_element_ui_lib_button___default.a);
// Vue.use(ButtonGroup);
__WEBPACK_IMPORTED_MODULE_39_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_26_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_39_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_24_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_39_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_22_element_ui_lib_date_picker___default.a);
// Vue.use(TimeSelect);
// Vue.use(TimePicker);
// Vue.use(Popover);
// Vue.use(Tooltip);
// Vue.use(Breadcrumb);
// Vue.use(BreadcrumbItem);
__WEBPACK_IMPORTED_MODULE_39_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_20_element_ui_lib_form___default.a);
__WEBPACK_IMPORTED_MODULE_39_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_18_element_ui_lib_form_item___default.a);
// Vue.use(Tabs);
// Vue.use(TabPane);
// Vue.use(Tag);
// Vue.use(Tree);
// Vue.use(Alert);
// Vue.use(Slider);
// Vue.use(Icon);
__WEBPACK_IMPORTED_MODULE_39_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_16_element_ui_lib_row___default.a);
__WEBPACK_IMPORTED_MODULE_39_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_col___default.a);
// Vue.use(Upload);
__WEBPACK_IMPORTED_MODULE_39_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_progress___default.a);
// Vue.use(Spinner);
// Vue.use(Badge);
// Vue.use(Card);
// Vue.use(Rate);
// Vue.use(Steps);
// Vue.use(Step);
// Vue.use(Carousel)
// Vue.use(CarouselItem)
// Vue.use(Collapse);
// Vue.use(CollapseItem);
// Vue.use(Cascader);
// Vue.use(ColorPicker);
// Vue.use(Transfer);
// Vue.use(Container);
// Vue.use(Header);
// Vue.use(Aside);
// Vue.use(Main);
// Vue.use(Footer);
// Vue.use(Timeline);
// Vue.use(TimelineItem);
// Vue.use(Link);
// Vue.use(Divider);
// Vue.use(Image);
// Vue.use(Calendar);
// Vue.use(Backtop);
// Vue.use(PageHeader);
// Vue.use(CascaderPanel);
__WEBPACK_IMPORTED_MODULE_39_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_link___default.a);
__WEBPACK_IMPORTED_MODULE_39_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_loading___default.a.directive);
__WEBPACK_IMPORTED_MODULE_39_vue__["default"].prototype.$loading = __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_loading___default.a.service;
__WEBPACK_IMPORTED_MODULE_39_vue__["default"].prototype.$msgbox = __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_message_box___default.a;
__WEBPACK_IMPORTED_MODULE_39_vue__["default"].prototype.$alert = __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_message_box___default.a.alert;
__WEBPACK_IMPORTED_MODULE_39_vue__["default"].prototype.$confirm = __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_message_box___default.a.confirm;
__WEBPACK_IMPORTED_MODULE_39_vue__["default"].prototype.$prompt = __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_message_box___default.a.prompt;
__WEBPACK_IMPORTED_MODULE_39_vue__["default"].prototype.$notify = __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_notification___default.a;
__WEBPACK_IMPORTED_MODULE_39_vue__["default"].prototype.$message = __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_message___default.a;
window.baseUrl =  true ? 'http://myfile.link' : 'http://localhost:2000';
__WEBPACK_IMPORTED_MODULE_39_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_42_vue_quill_editor___default.a, {
  theme: 'snow'
});
window.onresize = setHtmlFontSize;
function setHtmlFontSize() {
  var htmlWidth = document.documentElement.clientWidth || document.body.clientWidth;
  var htmlDom = document.getElementsByTagName('html')[0];
  htmlDom.style.fontSize = htmlWidth / 10 + 'px';
  if (parseInt(htmlDom.style.fontSize) > 100) htmlDom.style.fontSize = 100 + 'px';else if (parseInt(htmlDom.style.fontSize) < 24) htmlDom.style.fontSize = 24 + 'px';
  console.log('html fontsize:', htmlDom.style.fontSize);
};
setHtmlFontSize();
console.log('NODE_ENV:%s baseUrl:%s', "production", window.baseUrl);

__WEBPACK_IMPORTED_MODULE_39_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_39_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_41__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_40__App__["a" /* default */]);
  }
});

/***/ }),

/***/ "PuRO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "X+ky":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_home__ = __webpack_require__("wUZA");




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_home__["a" /* default */]
  }]
}));

/***/ }),

/***/ "Yq4J":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Zki6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cwe7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "d7TW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "isE6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "isgN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jZDA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oq7i":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "p+zA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qunJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rQBB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["queryVerify"] = queryVerify;
/* harmony export (immutable) */ __webpack_exports__["getHost"] = getHost;
/* harmony export (immutable) */ __webpack_exports__["requestAuth"] = requestAuth;
/* harmony export (immutable) */ __webpack_exports__["waitAuth"] = waitAuth;
/* harmony export (immutable) */ __webpack_exports__["InitCos"] = InitCos;
/* harmony export (immutable) */ __webpack_exports__["testCos"] = testCos;
/* harmony export (immutable) */ __webpack_exports__["GetCosInstance"] = GetCosInstance;
/* harmony export (immutable) */ __webpack_exports__["upload"] = upload;
/* harmony export (immutable) */ __webpack_exports__["submit"] = submit;
/* harmony export (immutable) */ __webpack_exports__["Encrypted"] = Encrypted;
/* harmony export (immutable) */ __webpack_exports__["Decrypted"] = Decrypted;
/* harmony export (immutable) */ __webpack_exports__["SHA1"] = SHA1;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);






var crypto = __webpack_require__("Av7u");

var COS = __webpack_require__("6qJD");

var protocol = window.location.protocol;
var hostname = window.location.hostname;
var port = window.location.port;
var _host = protocol + '//' + hostname + (port ? ':' + port : '');

console.log("_host:", _host);

var _cos = null;

function queryVerify(id, code, expireDate, sampleText) {
  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var url = _host + ('/getpassword?id=' + id + '&code=' + code + '&date=' + expireDate + '&text=' + sampleText);
    console.log("url:", url);
    var xhr = new XMLHttpRequest();
    xhr.open('get', url);
    xhr.onreadystatechange = function () {
      if (this.readyState === 4 && this.status === 200) {
        var data = JSON.parse(this.response);
        if (!data || data.code == 0) {
          console.log("获取官方密码错误：", data.message);
          resolve('验证码错误');
          return;
        }
        data = data.data;
        var credentials = data.credentials;
        if (!credentials) {
          console.error('credentials invalid:\n' + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(data, null, 2));
          resolve(null);
        };

        _cos = new COS({
          // getAuthorization 必选参数
          getAuthorization: function getAuthorization(options, callback) {
            callback({
              TmpSecretId: credentials.tmpSecretId,
              TmpSecretKey: credentials.tmpSecretKey,
              SecurityToken: credentials.sessionToken,
              // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
              StartTime: data.startTime, // 时间戳，单位秒，如：1580000000
              ExpiredTime: data.expiredTime // 时间戳，单位秒，如：1580000000
            });
          }
        });
        resolve(data.password);
      }
      //resolve(null)
    };
    xhr.send();
  });
}
function getHost() {
  return _host;
}
function requestAuth(id) {
  //请求后台获得二维码
  var url = _host + ('/requestAuth?id=' + id);

  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var xhr = new XMLHttpRequest();
    xhr.open('get', url);
    // xhr.setRequestHeader("Content-Type","application/x-www-form- urlencoded");
    xhr.send();
    xhr.onreadystatechange = function () {
      if (this.readyState === 4) {
        if (this.status === 200) {
          var data = JSON.parse(this.response);
          if (data.code == 0) resolve(data.data);else resolve(null);
        } else {
          console.log("getcaptcha err:", this.response);
          resolve(null);
        }
      }
    };
  });
}

function waitAuth(md5) {
  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  var url = _host + ('/captcharesult?token=' + md5);

  if (n > 20) return {
    code: 1 //二维码超时
  };
  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
    var xhr = new XMLHttpRequest();
    xhr.open('get', url);
    // xhr.setRequestHeader("Content-Type","application/x-www-form- urlencoded");
    xhr.send();
    xhr.onreadystatechange = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var r, data, _r;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(this.readyState === 4)) {
                _context.next = 20;
                break;
              }

              if (!(this.status == 502 || this.status == 400)) {
                _context.next = 8;
                break;
              }

              _context.next = 4;
              return waitAuth(md5, n + 1);

            case 4:
              r = _context.sent;

              resolve(r);
              _context.next = 20;
              break;

            case 8:
              if (!(this.status === 200)) {
                _context.next = 13;
                break;
              }

              data = JSON.parse(this.response);

              resolve(data);
              _context.next = 20;
              break;

            case 13:
              console.log("captcharesult err:", this.response);
              _context.next = 16;
              return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (rs) {
                return setTimeout(rs, 1000);
              });

            case 16:
              _context.next = 18;
              return waitAuth(md5, n + 1);

            case 18:
              _r = _context.sent;

              resolve(_r);

            case 20:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));
  });
}

function InitCos(data) {
  _cos = new COS({
    // getAuthorization 必选参数
    getAuthorization: function getAuthorization(options, callback) {
      callback({
        TmpSecretId: data.credentials.tmpSecretId,
        TmpSecretKey: data.credentials.tmpSecretKey,
        SecurityToken: data.credentials.sessionToken,
        // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
        StartTime: data.startTime, // 时间戳，单位秒，如：1580000000
        ExpiredTime: data.expiredTime // 时间戳，单位秒，如：1580000000
      });
    }
  });
}
function testCos() {
  var memoID = 12121;
  var url = _host + ('/sts?memoID=' + memoID);

  _cos = new COS({
    // getAuthorization 必选参数
    getAuthorization: function getAuthorization(options, callback) {
      var xhr = new XMLHttpRequest();
      xhr.open('get', url);
      // xhr.setRequestHeader("Content-Type","application/x-www-form- urlencoded");
      xhr.send();
      xhr.onreadystatechange = function () {
        if (this.readyState === 4) {
          if (this.status === 200) {
            var data = JSON.parse(this.response);
            var credentials = data.credentials;
            if (!credentials) {
              console.error('credentials invalid');
              return;
            };
            callback({
              TmpSecretId: credentials.tmpSecretId,
              TmpSecretKey: credentials.tmpSecretKey,
              SecurityToken: credentials.sessionToken,
              // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
              StartTime: data.startTime, // 时间戳，单位秒，如：1580000000
              ExpiredTime: data.expiredTime // 时间戳，单位秒，如：1580000000
            });
          }
        }
      };
    }
  });

  _cos.putObject({
    Bucket: 'myfile-1308181812',
    /* 填入您自己的存储桶，必须字段 */
    Region: 'ap-guangzhou',
    /* 存储桶所在地域，例如ap-beijing，必须字段 */
    Key: memoID + '.txt',
    /* 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段 */
    Body: 'this is test',
    SliceSize: 1024 * 1024 * 5,
    /* 触发分块上传的阈值，超过5MB使用分块上传，非必须 */
    onTaskReady: function onTaskReady(taskId) {
      /* 非必须 */
      console.log("上传taskID:", taskId);
    },
    onFileFinish: function onFileFinish(err, data, options) {
      /* 非必须 */
      console.log(options.Key + '上传' + (err ? '失败' : '完成'));
    }
  }, function (err, data) {
    console.log(err || data);
  });
}
function GetCosInstance() {
  return _cos;
}

function upload(id, content, readyCB, progressCB) {
  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
    _cos.putObject({
      Bucket: 'myfilelink-1308181812',
      /* 填入您自己的存储桶，必须字段 */
      Region: 'ap-guangzhou',
      /* 存储桶所在地域，例如ap-beijing，必须字段 */
      Key: id + '.txt',
      /* 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段 */
      Body: content,
      SliceSize: 1024 * 1024 * 5,
      /* 触发分块上传的阈值，超过5MB使用分块上传，非必须 */
      onTaskReady: readyCB,
      onProgress: progressCB

    }, function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(err, data) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log('上传结果:', err || data);
                //return 
                if (!err) resolve(data);else resolve(false);

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      return function (_x2, _x3) {
        return _ref2.apply(this, arguments);
      };
    }());
    //_that.bUploadDlg = false
  });
}

function submit(id, delayCode) {
  var url = _host + ('/submit?id=' + id + '&delayCode=' + delayCode);
  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {

    var xhr = new XMLHttpRequest();
    xhr.open('get', url);
    xhr.send();
    xhr.onreadystatechange = function () {
      if (this.readyState === 4) {
        if (this.status === 200) {
          var r = JSON.parse(this.response);
          if (r.code == 0) {
            resolve(null);
          } else resolve(true);
        }
        resolve(null);
      }
    };
  });
}

function Encrypted(key, content) {
  return crypto.AES.encrypt(content, key, {
    mode: crypto.mode.ECB,
    padding: crypto.pad.Pkcs7
  }).toString();
}

function Decrypted(key, content) {
  var bytes = crypto.AES.decrypt(content, key, {
    mode: crypto.mode.ECB,
    padding: crypto.pad.Pkcs7
  });
  return bytes.toString(crypto.enc.Utf8);
}

function SHA1(text) {
  return crypto.SHA1(text).toString();
}

/***/ }),

/***/ "tvR6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uKbn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wUZA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_vue__ = __webpack_require__("FGQs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64a4278b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_vue__ = __webpack_require__("4awP");
function injectStyle (ssrContext) {
  __webpack_require__("p+zA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64a4278b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.b8252db2ec7119bbe5bd.js